var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickaxe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 57.172 61.172)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 36,
    width: 14,
    height: 86,
    rx: 6,
    fill: "#a0642c",
    stroke: "#5c3714",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 46q54-44 108 0-54-16-108 0z",
    fill: "#b8c0c8",
    stroke: "#3d4650",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 28,
    width: 22,
    height: 20,
    rx: 3,
    fill: "#7d8790",
    stroke: "#3d4650",
    strokeWidth: 4
  }))));
}
export default SvgPickaxe;